import { render, staticRenderFns } from "./FacebookCallback.vue?vue&type=template&id=5f1af332&scoped=true"
import script from "./FacebookCallback.vue?vue&type=script&lang=js"
export * from "./FacebookCallback.vue?vue&type=script&lang=js"
import style0 from "./FacebookCallback.vue?vue&type=style&index=0&id=5f1af332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1af332",
  null
  
)

export default component.exports